import { makeAutoObservable, runInAction } from "mobx";
import { Email, PhoneNumber } from "../../form";
import { Availability } from "../Availability";
import { Locks } from "../Lock";
import { FullName } from "./FullName";
/**
 * Contact details needed for an online order.
 */
export class OnlineContactDetails {
    constructor(params) {
        this.type = "Online";
        this.locks = params.locks;
        this.validatePhoneService = params.validatePhoneService;
        this.fullName = params.fullName;
        this._email = params.email;
        this._phone = params.phone;
        makeAutoObservable(this);
    }
    static empty(validatePhoneService) {
        return new OnlineContactDetails({
            locks: new Locks(),
            validatePhoneService,
            fullName: FullName.empty(),
            email: Email.empty(),
            phone: PhoneNumber.empty(validatePhoneService),
        });
    }
    set email(value) {
        if (this.locked) {
            throw Error("Can't change email, ContactDetails locked due to: " +
                this.locks.serialized);
        }
        this._email = value;
    }
    get email() {
        return this._email;
    }
    setPhone(value, country) {
        if (this.locked) {
            throw new Error("Can't change phone number, ContactDetails locked due to: " +
                this.locks.serialized);
        }
        const phone = new PhoneNumber(value, country.toUpperCase(), this.validatePhoneService);
        runInAction(() => {
            this.phone = phone;
        });
    }
    get phone() {
        return this._phone;
    }
    set phone(value) {
        this._phone = value;
    }
    get locked() {
        return this.locks.locked;
    }
    /**
     * Prevent email and phone from being changed
     */
    // TODO: lock contact details if have active coupon with source = "FirstOrderDiscount"
    lock(owner) {
        return this.locks.addLock(owner);
    }
    /**
     * @returns data to be sent to the backend
     */
    get checkoutData() {
        var _a, _b, _c;
        return {
            email: (_a = this.email.value) !== null && _a !== void 0 ? _a : null,
            fullName: (_b = this.fullName.value) !== null && _b !== void 0 ? _b : "",
            phone: (_c = this.phone.value) !== null && _c !== void 0 ? _c : null,
        };
    }
    get availability() {
        return Availability.composite([
            this.fullName.availability,
            this.email.availability,
            this.phone.availability,
        ]);
    }
}
